import { render, staticRenderFns } from "./ClearDatabase.vue?vue&type=template&id=927b751c&"
import script from "./ClearDatabase.vue?vue&type=script&lang=js&"
export * from "./ClearDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports